<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="none" viewBox="0 0 96 96" id="paste">
  <path stroke="currentColor" stroke-width="5"
    d="M47 47C47 42.0294 51.0294 38 56 38H70.1358C71.9891 38 73.7669 38.735 75.0791 40.0438L79.9281 44.8804L81.1656 46.2334C82.3456 47.5237 83 49.209 83 50.9575V77C83 81.9706 78.9706 86 74 86H56C51.0294 86 47 81.9706 47 77V47Z">
  </path>
  <path stroke="currentColor" stroke-width="5"
    d="M70 38V19C70 14.0294 65.9706 10 61 10H43.5 21C16.0294 10 12 14.0294 12 19V77C12 81.9706 16.0294 86 21 86H59M70 39V49C70 50.6569 71.3431 52 73 52H83">
  </path>
  <path stroke="currentColor" stroke-linecap="round" stroke-width="5" d="M29 18C30.2 18 45.1667 18 52.5 18"></path>
</svg>